import UiPopup from '@/components/ui/Popup'

export default {
  install(Vue, { store, router }) {
    if(!store) {
      throw new Error('Please provide vuex store.')
    }
    const mixin = Vue.mixin({
      created() {
        this.$ui = Vue.$ui
        this.$store = store
        this.$popupRouter = router
      }
    })

    const Popup = Vue.extend(UiPopup)

    const instance = new Popup({
      el: document.createElement('div'),
      mixins: [mixin]
    })
    document.body.appendChild(instance.$el)

    const popup = {
      show(options) {
        instance.component = options.component
        instance.params = options.params ? options.params : {}
        instance.settings = options.settings ? options.settings : {}

        document.body.classList.add('Scroll--hidden')
        instance.show = true
        return new Promise((resolve, reject) => {
          instance.resolve = resolve
          instance.reject = reject
        })
      },

      hide() {
        document.body.classList.remove('Scroll--hidden')
        instance.show = false
      },

      ok(data) {
        this.hide()
        instance.resolve(data)
      },

      cancel(data) {
        this.hide()
        if(data && data.action === 'close') {
          instance.resolve(data)
        } else {
          instance.reject(data)
        }
      }
    }

    if(!Vue.$ui) {
      Vue.$ui = {
        popup
      }
    } else {
      Vue.$ui.popup = popup
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/popup.js